import * as $ from 'jquery';
import * as fileInput from "../modules/fileInput";
import * as formValidation from "../modules/formValidation";


declare const grecaptcha: any;

namespace BHW.registerProduct {

	const POST_REGISTERPRODUCT = '/api/salesforce/register-product';
	const VALIDATE_UPC ='/api/salesforce/validate-upc?upc=';
	
	let $form = $('form');
	let $registerForm = $('#register-product-form') as any;
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');
	let $errorList = $('.js-issues-need-correction');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $emailConfirm = $('#email-confirm');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
	let $state = $('#state');
	let $province = $('#province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');
	let $upc = $('#upc');
	let $datePurchased = $('#date-purchased');
	let $purchaseLocation = $('#purchase-location');
	let $uploadDocument = (<HTMLInputElement>document.getElementById('upload-document'));
	let uploadPhotoTranslation = 'Upload Photo Required';

	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');

	//patternChecks
	let zipcodePattern = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/;
	let datePattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'First Name Required'
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Last Name Required'
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Email Required'
			},
			email: {
				message: '^' + 'Email Invalid'
			}
		},
		'email-confirm': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Confirm Email Required'
			},
			equality: {
				attribute: 'email',
				message: '^' + 'Confirm Email Invalid'
			}
		},
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Address Required'
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Country Required'
			}
		},
		city: {
			presence: {
				allowEmpty: false,
				message: '^' + 'City Required'
			}
		},
		'state': {
			presence: {
				allowEmpty: false,
				message: '^' + 'State/Province Required'
			}
		},		
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Postal Code Required'
			},
			format: {
				pattern: zipcodePattern,
				message: '^' + 'Postal Code Format is not valid'
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + 'Phone Required'
			}
		},
		upc: {
			presence: {
				allowEmpty: false,
				message: '^' + 'UPC Required'
			}
		},
		'date-purchased': {
			presence: {
				allowEmpty: false,
				message:'^' + 'Date Purchased Required'
			},
			format: {
				pattern: datePattern,
				message:'^' + 'Date Invalid'
			},
			datetime: {
				dateOnly: true,
				latest: Date.now(),
				message:'^' + 'Date is Future Date'
			}

		},
		'purchase-location': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Purchase Location Required'
			}
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Captcha Required'
			}
		}
	};


	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: constraints,
			values: {
				'first-name': $firstName.val(),
				'last-name': $lastName.val(),
				email: $email.val().toString().toLowerCase(),
				'email-confirm': $emailConfirm.val().toString().toLowerCase(),
				address: $address.val(),
				address2: $address2.val(),
				country: $country.val(),
				city: $city.val(),
				'state': $state.val(),
				'province': $province.val(),
				'postal-code': $postalCode.val(),
				phone: $phone.val(),
				upc: $upc.val(),
				'date-purchased': $datePurchased.val(),
				'purchase-location': $purchaseLocation.val(),
				'recaptcha-token': grecaptcha.getResponse()
			}
		})) {
			// check form
		}
	};

	let setupHandlers = function(){
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function(){
			$('input[type=file]').off('change.file');
			$('#upload-document').on('change.upload', function(){
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				if (((this) as any).files && ((this) as any).files[0]) {
					if($this.data("accept")) {
						let fileAssocArray = $this.data("accept").split(',');
						let fileName = ((this) as any).files[0].name;
						let fileExt = fileName.split(/[. ]+/).pop().toLowerCase();
						// console.log(`${fileAssocArray}, ${fileName}, ${fileExt}`);

						if(fileAssocArray.indexOf(`.${fileExt}`) > -1) {
							$value.html( ((this) as any).files[0].name );
							$value.append('<i class="icon icon-times file-input-close js-reset-file" title="Remove Image"></i>');
							validateField();
						} else {
							alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
						}
					} else {
						$value.html(((this) as any).files[0].name );
						$value.append('<i class="icon icon-times file-input-close js-reset-file" title="Remove Image"></i>');
						validateField();

					}
				} else {
					$value.html('');
					validateField();

				}
			});
		}, 1000);

		$('body').on('click.register', '.js-reset-file', function(e){
			validateField();
			e.preventDefault();
		});
	};

	let setUPCValue = function(){
		let urlParams = new URLSearchParams(window.location.search);
		let upcParam = urlParams.get('upc');

		if(upcParam && upcParam.length) {
			$upc.val(upcParam);
		}
	};

	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);
		$emailConfirm.on('blur change', validateField);
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);
		if ($country.val() == "CAN") {
            $province.on('blur change', validateField);
        }
        else {
            $state.on('blur change', validateField);
        }		
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);
		$upc.on('blur change', validateField);
		$datePurchased.on('blur change', validateField);
		$purchaseLocation.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});
	};
	let countryChange = function () {$country.on('change',function () {
        if ($(this).val() == "CAN") {
            $("#divprovince").show();
            $("#divstate").hide();
        }
        else {
            $("#divprovince").hide();
            $("#divstate").show();
        }
    });
};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');

			let $fileHasValue = $uploadDocument.files.length > 0 ;	
			let stateProvince = $state.val()
			if ($country.val() == "CAN") {
			   stateProvince = $province.val();
			}
			if (formValidation.validateWrapperSubmit({
					constraints: constraints,
					values: {
						'first-name': $firstName.val(),
						'last-name': $lastName.val(),
						email: $email.val().toString().toLowerCase(),
				       'email-confirm': $emailConfirm.val().toString().toLowerCase(),
						address: $address.val(),
						address2: $address2.val(),
						country: $country.val(),
						city: $city.val(),
						'state': stateProvince,					
						'postal-code': $postalCode.val(),
						phone: $phone.val(),
						upc: $upc.val(),
						'date-purchased': $datePurchased.val(),
						'purchase-location': $purchaseLocation.val(),
						'recaptcha-token': grecaptcha.getResponse()
					}
				}) && $fileHasValue === true) {
				// check form
			} else {
				if($fileHasValue === false) {
					$(`<li>${uploadPhotoTranslation}</li>`).appendTo($errorList);
				}
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}

			let data = new FormData();
			let contactInfo = JSON.stringify({
				FirstName: $firstName.val(),
				LastName: $lastName.val(),
				Email: $email.val(),
				Address1: $address.val(),
				Address2: $address2.val(),
				Country: $country.val(),
				City: $city.val(),
				State: stateProvince,
				PostalCode: $postalCode.val(),
				Phone: $phone.val()
			});
			let product = JSON.stringify({
				UpcCode: $upc.val(),
				DatePurchased: $datePurchased.val(),
				PurchaseLocation: $purchaseLocation.val()
			});

			data.append("ContactInfo", contactInfo);
			data.append("Product", product);
			data.append("File", (<HTMLInputElement>document.getElementById('upload-document')).files[0]);

			$.ajax({
				url: POST_REGISTERPRODUCT,
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			})
			.done(function (data) {
				if(data['errorMessage'] == null || data['errorMessage'] == "")
				{			
					if(!data['upcVerified']) 
						{
							let upcNotValid = 'UPC Code Not Valid';
							$alertDanger
							.removeClass('hidden')
							.find('.js-alert-text')
							// TODO: verify this text
							.text(upcNotValid);

						window.scrollTo(0, 0);
						$submit.removeClass('hidden');
						$pleaseWait.addClass('hidden');
						}
					if( data['upcVerified'] && data['isRegistered'])
						{
						$alertSuccess.removeClass('hidden');
						$registerForm[0].reset();
						formValidation.resetForm($form);
						$('.js-file-input-value').text('');		
					    }
				}
				else{
					$alertDanger
					.removeClass('hidden')
					.find('.alert__text')
					.text(data['errorMessage']);
				}						
			})
			.fail(function (response) {
					$alertDanger
					.removeClass('hidden')
					.find('.alert__text');
					
			})
			.always(function () {
					window.scrollTo(0, 0);
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
			});
		});
	};

	export function init() {
		setupHandlers();		
		fileInput.init();		
		inputEventListeners();
		submitEventListener();
		setUPCValue();
		countryChange();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	BHW.registerProduct.init();
});
